module.exports = fox._r("images/favorites.png", __webpack_public_path__ + "images/favorites.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/favorites.png
// module id = 1046
// module chunks = 4